import { Footer } from '@components/footer';
import { SvgSources } from '@components/icons/svgSources';
import { Navbar } from '@components/navbar';
import { Toaster } from '@components/ui/toast/toaster';
import { UploadQueue } from '@components/uploadQueue';
import { useAppContext } from '@contexts/app';
import { DropdownsProvider } from '@contexts/dropdowns';
import { cn } from '@utils/cn';
import { appRoutes, foremanRoute } from '@utils/consts';
import { handleLanguageChange } from '@utils/i18n';
import { useEffect, useMemo } from 'react';
import { Location, Outlet, useLocation, useParams } from 'react-router';
import { AppScrollRestoration } from '@components/scrollRestoration';
import { APP_SCROLL_CLASS, APP_SUBHEADER_SLOT_ID } from '@hooks/appScroll/constants';
import { useRefreshChannel } from '@hooks/refreshChannel';

const getScrollKey = (location: Location) =>
  location.pathname.includes(foremanRoute.index) ? location.pathname : location.key;

export const Layout = () => {
  const { isLogged: isUserLogged, admin, pushEnabled } = useAppContext();
  const { pathname } = useLocation();
  const { lang } = useParams();
  const isLogged = isUserLogged || admin?.isLogged;

  const notFound = pathname.includes(appRoutes.notFound);

  useRefreshChannel();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    handleLanguageChange(lang || 'en');
  }, [lang]);

  const outletKey = useMemo(() => (pushEnabled ? new Date().toISOString() : ''), [pushEnabled]);

  return (
    <DropdownsProvider>
      <div
        className={cn(
          'flex min-h-screen w-full flex-col md:h-dv md:min-h-0 md:overflow-hidden',
          isLogged && !notFound ? '' : 'login-page',
        )}>
        <SvgSources />
        <Navbar />
        <div id={APP_SUBHEADER_SLOT_ID} className="contents" />
        {/* <Tutorial /> */}
        <div
          className={cn(
            APP_SCROLL_CLASS,
            'scrollbar-md flex grow flex-col md:min-h-0 md:overflow-y-auto md:[scrollbar-gutter:stable]',
          )}>
          <main
            key={outletKey}
            className={cn(
              'main mx-auto w-full pb-5 p-5',
              isLogged && !notFound ? 'grow' : 'pt-10',
            )}>
            <Outlet />
          </main>
          <Footer isCompact={!isLogged || notFound} />
        </div>
        <AppScrollRestoration getKey={getScrollKey} />
        <Toaster />
        <UploadQueue />
      </div>
    </DropdownsProvider>
  );
};
